<style lang="stylus">
    .invitetips
        color #222222

        span
            color #FF7100
            cursor pointer
            &:hover
                text-decoration underline
</style>
<template>
    <WarnTips
        :show="showFileNumTips"
        :normalText="$t('description', { fileNum: limitFileNum })"
        :vipText="$t('tobuy')"
        :triggerStr="'cloudFileFloat'"
        @clickBuy="clickBuy"
    >
        <template #invite>
            <span v-if="showInvite" class="invitetips">
                <span @click="openInvite">{{ $t("invitebtn") }}</span>
                {{ $t("invite") }}
            </span>
        </template>
    </WarnTips>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import WarnTips from "./WarnTips.vue";

    @Component({
        components: {
            WarnTips,
        },
    })
    export default class FileNum extends Vue {
        get showFileNumTips() {
            return this.$store.getters.showFileNumTips(this);
        }
        get limitFileNum() {
            return this.$store.state.limitFileNum || 3;
        }
        count = 0;
        clickBuy() {
            if (this.count >= 3) return;
            this.count++;
            console.log(this.count);
        }
        get userInfo() {
            return this.$store.state.userInfo || this.$store.state.user.userInfo;
        }
        get showInvite() {
            return this.internal && this.count == 3;
        }
        openInvite() {
            let custom = encodeURIComponent(btoa(JSON.stringify({ id: this.userInfo.user_id, token: this.userInfo.token })));
            const url = "https://www.edrawmax.cn/useractivity/" + `?custom=${custom}`;
            let win: any = window;
            if (win.$qt) {
                win.$qt.jsCallOpenUrl(url);
            } else {
                window.open(url);
            }
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "description": "非会员仅可编辑最近创建的{fileNum}个云文件，其余的仅供查看，",
        "tobuy": "开通VIP尊享无限编辑文件",
        "invitebtn": "邀请好友",
        "invite": "可免费获得3个编辑文件，"
    },
    "en": {
        "description": "Free users can only edit {fileNum} recently created Cloud Document(s). Other documents are view-only. ",
        "tobuy": "Upgrade to Premium for unlimited editing.",
        "invitebtn": "Invite new users ",
        "invite": "to get 3 extra editable documents for free."
    },
    "fr": {
        "description": "Les utilisateurs de la version gratuite ne peuvent modifier que {fileNum} document(s) cloud récemment créé(s). ",
        "tobuy": "Passez à la version Premium pour une édition illimitée."
    },
    "de": {
        "description": "Benutzer der kostenlosen Version können nur {fileNum} Cloud-Dokument(e) bearbeiten, die zuletzt erstellt wurden.Alle anderen Dokumente sind nur zur Ansicht verfügbar.  ",
        "tobuy": "Führen Sie ein Upgrade auf Premium durch, um Bearbeitungen ohne Einschränkungen zu erhalten."
    },
    "jp": {
        "description": "無料ユーザーは、最近作成した {fileNum} 個のクラウドドキュメントのみを編集できます。他のドキュメントは表示専用になります。",
        "tobuy": "無制限の編集を得るには、プレミアムにアップグレードしてください。"
    },
    "es": {
        "description": "Los usuarios gratuitos solo pueden editar {fileNum} documentos en la nube creados recientemente. El resto serán solo para su visualización. ",
        "tobuy": "Actualice a Premium para editar de forma ilimitada."
    },
    "pt": {
        "description": "Os usuários da versão gratuita só podem editar {fileNum} documento(s) recém-criado(s) na nuvem. Os demais documentos podem ser visualizados apenas. ",
        "tobuy": "Atualize para a versão Premium para editar sem limites."
    },
    "it": {
        "description": "Gli utenti gratuiti possono modificare solo {fileNum} documenti cloud creati di recente. Gli altri documenti sono disponibili per la sola visualizzazione. ",
        "tobuy": "Passa alla versione Premium per modifiche illimitate"
    },
    "tw": {
        "description": "免費使用者只能編輯最近建立的 {fileNum} 份雲端文件。其他文件僅供檢視。",
        "tobuy": "升級至 Premium 以享有無限編輯權限。"
    },
    "kr": {
        "description": "무료 사용자는 최근에 생성된 클라우드 문서 {fileNum}개만 편집할 수 있습니다. 다른 문서는 보기 전용입니다. ",
        "tobuy": "프리미엄으로 업그레이드하여 무제한 편집을 이용하십시오."
    },
    "id": {
        "description": "Pengguna Gratis hanya dapat mengedit {fileNum} Dokumen Cloud yang baru dibuat. Dokumen lain hanya dapat dilihat. ",
        "tobuy": "Tingkatkan ke Premium untuk pengeditan tak terbatas."
    }
}
</i18n>
